//Default imports
import React, { useState } from 'react';

//Icons
import { BiMenu } from 'react-icons/bi';

// Importing the styled components
import {
  BigText,
  Container,
  Box,
  HeroContainer,
  InfoText,
  LMButton,
  LeftSection,
  Links,
  LinksContainer,
  Logo,
  LogoArea,
  NavBarContainer,
  RightSection,
  Slashes,
  SmallText,
  Heart,
  LeftInformationContainer,
  HeartImageContainer,
  FirstCircle,
  SecondCircle,
  HeartImage,
  SubRightSection,
} from './TopSectionStyles';

import {
  MenuToggle,
  HiddenContainer,
  CloseIcon,
  HiddenButtonContainer,
  LeftArea,
  AboutUsBox,
  Heading,
  LinksSection,
  LinksH,
  ProjectsBox,
  NewsBox,
  RightArea,
  PartnerBox,
  InitiativesBox,
  ContactBox,
} from './NavbarStyled';

//Logo


//Icons

//Dropdown
import Dropdown from '../Utils/Dropdown';

export default function TopSection() {
  const [toggleMenu, setToggleMenu] = useState(false);

  const handleToggleOpen = () => {
    setToggleMenu(true);
  };

  const handleToggleClose = () => {
    setToggleMenu(false);
  };
  // About Functionality
  const dropdownOptionsAbout = ['Description', 'Attributions', 'Sponsors']; // Option for About Dropdown
  const aboutRoutes = ['/description', '/attributions', '/sponsors'];

  // Initiatives Functionality
  const dropdownOptionsInitiatives = [
    'Engineering',
    'Results',
    'Contributions'
  ]; // Option for Initiatives Dropdown
  const initiativesRoutes = [
    '/engineering',
    '/results',
    '/contribution'
  ];

  // Projects Functionality
  const dropdownOptionsProjects = [
    'Kinetic Model',
    'Normalization Model',
    'Safety'
  ]; // Option for Projects Dropdown
  const projectsRoutes = [
    '/kineticmodel',
    '/normalizationmodel',
    '/safety'
  ];

  const dropdownOptionsNews = [
    'Overview',
    'Treatment Report',
    'Entrepreneurship',
    'Integrated Human Practices',
    'Womens Report',
  ]; // Option for News Dropdown
  const newsRoutes = [
    '/overview',
    '/treatment-report',
    '/entrepreneurship',
    '/human-practices',
    '/womensreport',
  ];

  return (
    <>
    <Container>
      <Box>
        <NavBarContainer>
          <LogoArea>
            <Links route='/'><a href="/mcmaster-canada"><Heart src='https://static.igem.wiki/teams/4751/wiki/mgemlogo.png' /></a></Links>
          </LogoArea>
          <LinksContainer>
            <Links>
              <Dropdown
                options={dropdownOptionsAbout}
                routes={aboutRoutes}
                navItemName="ABOUT"
              />
            </Links>
            <Slashes>/</Slashes>
            <Links>
              {' '}
              <Dropdown
                options={dropdownOptionsInitiatives}
                routes={initiativesRoutes}
                navItemName="WET LAB"
              />
            </Links>
            <Slashes>/</Slashes>
            <Links>
              {' '}
              <Dropdown
                options={dropdownOptionsProjects}
                routes={projectsRoutes}
                navItemName="DRY LAB"
              />
            </Links>
            <Slashes>/</Slashes>
            <Links>
              {' '}
              <Dropdown
                options={dropdownOptionsNews}
                routes={newsRoutes}
                navItemName="OVERVIEW OF HUMAN PRACTICES"
              />
            </Links>
            <MenuToggle onClick={handleToggleOpen}>
                <BiMenu />
            </MenuToggle>
          </LinksContainer>
        </NavBarContainer>
        <HeroContainer>
          <LeftSection>
            <LeftInformationContainer>
              <BigText>INTRODUCING iGEM MCMASTER</BigText>
              <SmallText>/ SILVER AWARD AT IGEM 2023</SmallText>
            </LeftInformationContainer>
            <HeartImageContainer>
              <FirstCircle>
                <SecondCircle>
                  <HeartImage src="https://static.igem.wiki/teams/4751/wiki/mgemlogo.png" />
                </SecondCircle>
              </FirstCircle>
            </HeartImageContainer>
          </LeftSection>
          <RightSection>
            <SubRightSection>
              <InfoText>
                A big thank you to all our sponsors!
              </InfoText>
              <LMButton to="/sponsors">
                Learn More
              </LMButton>
            </SubRightSection>
          </RightSection>
        </HeroContainer>
      </Box>
    </Container>
    {toggleMenu && (
        <HiddenContainer>
          <CloseIcon onClick={handleToggleClose}>&times;</CloseIcon>
          <HiddenButtonContainer>
            <LeftArea>
              <AboutUsBox>
                <Heading>ABOUT</Heading>
                <LinksSection>
                  <LinksH to="/description">Description</LinksH>
                  <LinksH to="/attributions">Attributions</LinksH>
                  <LinksH to="/sponsors">Sponsors</LinksH>
                </LinksSection>
              </AboutUsBox>
              <ProjectsBox>
                <Heading>WET LAB</Heading>
                <LinksSection>
                  <LinksH to="/engineering">Engineering</LinksH>
                  <LinksH to="/results">Results</LinksH>
                  <LinksH to="/contribution">Contributions</LinksH>
                </LinksSection>
              </ProjectsBox>
              <NewsBox>
                <Heading>DRY LAB</Heading>
                <LinksSection>
                  <LinksH to="/kineticmodel">Kinetic Model</LinksH>
                  <LinksH to="/normalizationmodel">Normalization Model</LinksH>
                  <LinksH to="/safety">Safety</LinksH>
                </LinksSection>
              </NewsBox>
            </LeftArea>
            <RightArea>
              <PartnerBox>
                <Heading>HUMAN PRACTICES</Heading>
                <LinksSection>
                  <LinksH to="/overview">Overview</LinksH>
                  <LinksH to="/treatment-report">Treatment Report</LinksH>
                  <LinksH to="/entrepreneurship">Entrepreneurship</LinksH>
                  <LinksH to="/human-practices">Integrated Human Practices</LinksH>
                  <LinksH to="/womensreport">Women's Report</LinksH>
                </LinksSection>
              </PartnerBox>
            </RightArea>
          </HiddenButtonContainer>
        </HiddenContainer>
      )}
    </>
  );
}
